import script from "./Sider.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sider.vue?vue&type=script&lang=ts&setup=true"

import "./Sider.vue?vue&type=style&index=0&id=1c4d5bf6&lang=css"

const __exports__ = script;

export default __exports__